<template>
  <company-option-style>
    <div class="tab-info">
      <div class="columns">
        <div class="column">
          <div class="alert-content">
            <div class="con-vs-alert con-vs-alert-primary con-icon">
              <div class="vs-alert con-icon">
                <i class="vs-icon
                        notranslate
                        icon-scale icon-alert
                        material-icons
                        null">
                  new_releases
                </i>
                Asigne el código de parkline si el usuario trabaja con el sistema anterior
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-4">
          <b-field label="Código parkline">
            <b-input placeholder="Código parkline"
                     type="text" name="usucodigo"
                     v-model="accessDetail.usucodigo"/>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field label="Número de tarjeta">
            <b-input placeholder="Tarjeta administrativa"
                     type="text"
                     v-model="accessDetail.cardId"/>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="menu-item" v-for="appAccess in accessDetail.appList">
            <menu-option :node="0" :app-access="appAccess"/>
          </div>
        </div>
      </div>
    </div>
  </company-option-style>
</template>

<script>
import CheckboxCustom from "@/components/Shared/CheckboxCustom";
import MenuOption from "@/views/users/user/component/MenuOption";
import CompanyOptionStyle from "@/views/users/user/component/CompanyOptionStyle";


export default {
  name: "CompanyOptions",
  components: {CheckboxCustom, MenuOption, CompanyOptionStyle},
  props: {
    accessDetail: Object
  },
  data() {
    return {};
  }
}
</script>

<style scoped>
.tab-info {
  padding: 20px 5px;
}
</style>